import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, createStandaloneToast, mode, Text, useColorMode } from '@abb/uikit';
import { onMessageListener, requestForToken } from 'firebaseinit';
import React from 'react';
const NotificationProvider = ()=>{
    const { ToastContainer, toast } = createStandaloneToast();
    const { colorMode } = useColorMode();
    const [notification, setNotification] = React.useState({
        title: '',
        body: ''
    });
    const notify = ()=>toast({
            position: 'top-right',
            duration: 9000,
            isClosable: true,
            render: ()=>/*#__PURE__*/ _jsxs(Box, {
                    bg: mode('#EDF2F7', 'gray.700')({
                        colorMode
                    }),
                    boxShadow: "0px 4px 6px -1px rgba(0, 0, 0, 0.04), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
                    padding: "12px 16px",
                    borderRadius: "6px",
                    border: `1px solid ${mode('#E2E8F0', '#718096')({
                        colorMode
                    })}`,
                    mr: "40px",
                    mt: "50px",
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            color: mode('black', 'white')({
                                colorMode
                            }),
                            fontWeight: 600,
                            wordBreak: "break-word",
                            width: "250px",
                            noOfLines: [
                                1,
                                2
                            ],
                            children: notification === null || notification === void 0 ? void 0 : notification.title
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            color: mode('black', 'white')({
                                colorMode
                            }),
                            wordBreak: "break-word",
                            width: "250px",
                            noOfLines: [
                                1,
                                2
                            ],
                            children: notification === null || notification === void 0 ? void 0 : notification.body
                        })
                    ]
                })
        });
    React.useLayoutEffect(()=>{
        requestForToken();
        onMessageListener().then((payload)=>{
            var _payload_notification, _payload_notification1;
            setNotification({
                title: payload === null || payload === void 0 ? void 0 : (_payload_notification = payload.notification) === null || _payload_notification === void 0 ? void 0 : _payload_notification.title,
                body: payload === null || payload === void 0 ? void 0 : (_payload_notification1 = payload.notification) === null || _payload_notification1 === void 0 ? void 0 : _payload_notification1.body
            });
        }).catch((err)=>console.log('failed: ', err));
    }, []);
    React.useEffect(()=>{
        if (notification === null || notification === void 0 ? void 0 : notification.title) {
            notify();
        }
    }, [
        notification
    ]);
    return /*#__PURE__*/ _jsx(ToastContainer, {});
};
export default /*#__PURE__*/ React.memo(NotificationProvider);
